<template>
  <div>
    <EnvironmentHeader />
    <MainHeader />
  </div>
</template>

<script>
import EnvironmentHeader from './EnvironmentHeader.vue';
import MainHeader from './MainHeader.vue';

export default {
  name: 'Header',
  components: {
    EnvironmentHeader,
    MainHeader
  }
};
</script>

<style lang="scss">
@import '@/assets/stylesheets/variables.scss';

.header {
  display: block;
  background: $secondary-darken-2;
  // background: linear-gradient(to right, #008bae 0%,#0086a7 200%);
  height: 150px;
}
</style>
